var React = require('react');

function AngleUpRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M168.5 164.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 229.3 40.3 347.8c-4.7 4.7-12.3 4.7-17 0L3.5 328c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0z"}));
}

AngleUpRegular.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"far","data-icon":"angle-up","className":"svg-inline--fa fa-angle-up fa-w-10","role":"img","viewBox":"0 0 320 512"};

module.exports = AngleUpRegular;

AngleUpRegular.default = AngleUpRegular;
